import ReportListItem from './ReportListItem';
export default ReportListItem;



// WEBPACK FOOTER //
// ./src/scenes/Reports/components/ReportList/components/ReportListItem/index.js